// extracted by mini-css-extract-plugin
export default {"inner":"ChoicePlot_inner__GRzw1","outer":"ChoicePlot_outer__8RmrI","dry":"ChoicePlot_dry__021Sc","medium":"ChoicePlot_medium__E5FmQ","wet":"ChoicePlot_wet__L4qIB"};